import React from 'react';
import type { LeaderboardContestant } from './ContestLeaderboard';
import styles from './BestRun.module.scss';
import { Callout } from '../Callout/Callout';
import {
  ContestLeaderboardGrid,
  LeaderboardCell,
  useContestLeaderboard,
} from './ContestLeaderboard';
import { LeaderboardGameType } from './LeaderboardGameLogic';
import { useAccount } from '../../contexts/AccountContext';

export type BestRunProps = {
  gameType: LeaderboardGameType;
  bestRun: LeaderboardContestant | null;
  hide: boolean;
};

export function BestRun({ bestRun, gameType }: BestRunProps) {
  const table = useContestLeaderboard(gameType, bestRun ? [bestRun] : [], {
    displayMedal: true,
  });

  return (
    <section className={styles.body}>
      <h2 className="small-title">Your best qualifying run</h2>
      <Callout>
        {!bestRun && <span>You have not yet qualified for this contest. Play today!</span>}
        <ContestLeaderboardGrid table={table}>
          {table
            .getRowModel()
            .rows.flatMap((row) =>
              row.getVisibleCells().map((cell) => <LeaderboardCell cell={cell} key={cell.id} />),
            )}
        </ContestLeaderboardGrid>
      </Callout>
    </section>
  );
}

/**
 * Hiding the best run part if the user isn't logged in
 * @param props
 * @constructor
 */
export function BestRunAccountGated(props: BestRunProps) {
  const { account } = useAccount();

  if (props.hide || !account.dusktech?.userId) {
    return null;
  }

  return <BestRun {...props} />;
}
